// import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
// import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
//import { Form, Input } from 'src/components/Antd';
import { OriNumberInput } from 'src/components/Antd/NumberInput/NumberInput';
import { Select } from 'src/components/Antd/Select';
// import {
//   EnumFieldType,
//   SelectorType,
//   Type,
// } from 'src/components/FieldModal/config';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
import { useGetAreaCodeText } from 'src/hooks/useGetAreaCodeText';
// import { useI18n } from 'src/hooks/useRouterChange';
// import { hasValue, onFinishFailed, timeoutScroll } from 'src/tools/helper';
// import { responseHandler } from 'src/tools/server';
// import { i18nGet } from 'src/tools/tools';
// import { modal } from 'src/utils/Modal';
// import { FiledNameKeyMapping, OptionKeyMapping } from '../../config';
import css from './css.module.less';

const Option = Select.Option;

const MobileNumberAreaInfo = (props) => {
  const {
    value,
    onChange,
    id, //options,
    disabled,
    mobileKey = 'mobileNumber',
  } = props;
  const { areaCodeInfo: a, [mobileKey]: m } = value || {};
  const [areaCodeInfo, setAreaCodeInfo] = React.useState(a);
  const [mobileNumber, setMobileNumber] = React.useState(m);
  React.useEffect(() => {
    if (get(areaCodeInfo, 'uuid') !== get(a, 'uuid')) {
      setAreaCodeInfo(a);
    }
    if (mobileNumber !== m) {
      setMobileNumber(m);
    }
  }, [value]);
  const handleCodeChange = (areaCodeInfo) => {
    setAreaCodeInfo(areaCodeInfo);
    onChange({
      areaCodeInfo,
      [mobileKey]: mobileNumber,
    });
  };
  const handleMobileChange = (mobile) => {
    setMobileNumber(mobile);
    onChange({
      areaCodeInfo,
      mobileNumber: mobile,
    });
  };

  return (
    <div id={id} className={css.mobileContainer}>
      <AreaCodeInfo
        disabled={disabled}
        className={css.select}
        value={areaCodeInfo}
        onChange={handleCodeChange}></AreaCodeInfo>
      <PhoneNumber
        onChange={handleMobileChange}
        value={mobileNumber}
        disabled={disabled}
        className={css.numberInput}
      />
    </div>
  );
};

const AreaCodeInfo = (props) => {
  const {
    value,
    onChange,
    id, //options,
    disabled,
    className,
    displayOnly,
    options: o,
  } = props;

  const options = useSelector(getAreaCodes());

  const iniV = get(value, 'uuid');
  const [areaCode, setAreaCode] = React.useState(iniV);

  const areaCodeInText = useGetAreaCodeText(areaCode);
  React.useEffect(() => {
    if (areaCode !== iniV) {
      setAreaCode(iniV);
    }
  }, [iniV]);
  const handleCodeChange = (code) => {
    setAreaCode(code);
    onChange({ uuid: code });
  };

  return (
    <div id={id}>
      {displayOnly ? (
        areaCodeInText
      ) : (
        <Select
          filterOption={(input: any, option: any) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          showSearch
          disabled={disabled}
          allowClear
          size='large'
          containerClassName={`${css.select} ${className || ''}`}
          dropdownMatchSelectWidth={320}
          // open
          value={areaCode}
          onChange={handleCodeChange}>
          {(o || options || []).map((i) => {
            const { areaCode, name, value, uuid } = i;
            const label = `${name} (+${areaCode})`;

            return (
              <Option value={uuid} key={uuid || value} title={label}>
                {label}
              </Option>
            );
          })}
        </Select>
      )}
    </div>
  );
};

const PhoneNumber = (props) => {
  const {
    value,
    onChange,
    id, //options,
    disabled,
    className,
  } = props;

  // const options = [
  //   { label: 'a 0', value: '0' },
  //   { label: 'c 1', value: '1' },
  // ];

  const [mobileNumber, setMobileNumber] = React.useState(value);
  React.useEffect(() => {
    if (mobileNumber !== value) {
      setMobileNumber(value);
    }
  }, [value]);

  const handleMobileChange = (mobile) => {
    setMobileNumber(mobile);
    onChange(mobile);
  };

  return (
    <div id={id} className={className || ''}>
      <OriNumberInput
        onChange={handleMobileChange}
        value={mobileNumber}
        size='large'
        className={`${css.numberInput} `}
        disabled={disabled}
      />
    </div>
  );
};

const AreaCodeText = (props) => {
  const { areaCodeUuid } = props;
  const areaCodeInText = useGetAreaCodeText(areaCodeUuid);
  return areaCodeInText || '';
};

export { PhoneNumber, AreaCodeInfo, MobileNumberAreaInfo, AreaCodeText };
